function initVietikiATCScrollTracker() {
  const trigger = document.getElementById('vietiki-main-atc-trigger');
  const bar = document.querySelector('.vietiki-premium-sticky-bar');
  const stickySelect = document.querySelector('.vietiki-sticky-variant-select');
  
  if (!trigger || !bar || bar.dataset.initialized === 'true') return;
  bar.dataset.initialized = 'true';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        bar.classList.add('show-sticky');
      } else {
        bar.classList.remove('show-sticky');
      }
    });
  }, { threshold: 0, rootMargin: '0px' });

  observer.observe(trigger);

  if (stickySelect) {
    stickySelect.addEventListener('change', (e) => {
      const variantId = e.target.value;
      const formId = bar.dataset.formId;
      
      const masterInput = document.querySelector(`form[id="${formId}"] input[name="id"]`);
      if (masterInput) {
        masterInput.value = variantId;
      }

      const selectedOption = e.target.options[e.target.selectedIndex];
      if (!selectedOption) return;

      const op1 = selectedOption.getAttribute('data-op1');
      const op2 = selectedOption.getAttribute('data-op2');
      const op3 = selectedOption.getAttribute('data-op3');
      const optionsToSync = [op1, op2, op3].filter(val => val !== null && val !== undefined && val !== '');
      const mainForm = document.getElementById(formId);
      const container = mainForm ? mainForm.closest('product-info, .product__info-container, .product-single') : document;
      if (!container) return;

      const radioGroups = container.querySelectorAll('variant-radios fieldset, .variant-radios fieldset, variant-radios .js-product-form__input');
      const selectGroups = container.querySelectorAll('variant-selects select, .variant-selects select, select[id^="Option-"]');
      const optionGroups = container.querySelectorAll('variant-selects .product-form__input');

      if (radioGroups.length > 0) {
        optionsToSync.forEach((val, index) => {
          if (radioGroups[index]) {
            const safeVal = val.replace(/"/g, '\\"');
            const radio = radioGroups[index].querySelector(`input[type="radio"][value="${safeVal}"]`);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      } else if (optionGroups.length > 0) {
        // One group per option, in order; each group is either a dropdown or picture/pill radios
        optionsToSync.forEach((val, index) => {
          const group = optionGroups[index];
          if (!group) return;
          const safeVal = val.replace(/"/g, '\\"');
          const radio = group.querySelector(`input[type="radio"][value="${safeVal}"]`);
          const select = group.querySelector('select');
          if (radio) {
            if (!radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (select && select.value !== val) {
            select.value = val;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else if (selectGroups.length > 0) {
        optionsToSync.forEach((val, index) => {
          const select = selectGroups[index];
          if (select && select.value !== val) {
            select.value = val;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        optionsToSync.forEach((val) => {
          const safeVal = val.replace(/"/g, '\\"');
          const radio = container.querySelector(`input[type="radio"][value="${safeVal}"]`);
          if (radio) {
            if (!radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            const selects = container.querySelectorAll('select');
            selects.forEach(select => {
              if (select !== stickySelect && Array.from(select.options).some(o => o.value === val)) {
                if (select.value !== val) {
                  select.value = val;
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
          }
        });
      }
    });
  }

  const productInfo = document.querySelector('product-info') || document.querySelector('.product__info-container');
  if (productInfo && stickySelect) {
    productInfo.addEventListener('change', () => {
      setTimeout(() => {
        const formId = bar.dataset.formId;
        const masterInput = document.querySelector(`form[id="${formId}"] input[name="id"]`);
        if (masterInput) {
          if (stickySelect.value !== masterInput.value) stickySelect.value = masterInput.value;
          const stickyPriceContainer = bar.querySelector('.vietiki-sticky-current-price');
          const mainPriceContainer = productInfo.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price__container .price-item');
          if (stickyPriceContainer && mainPriceContainer) {
            stickyPriceContainer.textContent = mainPriceContainer.textContent.trim();
          }
        }
      }, 100);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVietikiATCScrollTracker);
} else {
  initVietikiATCScrollTracker();
}

(function () {
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      initVietikiATCScrollTracker();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
